

var article2 = `
**NOTA:** para agregar estos repositorios ver [enlace para configurar los repositorios]().

### Repositorios de Ubuntu Kinetic

> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic** main restricted
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** main restricted
>
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic** universe
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** universe
>
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic** multiverse
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic-updates** multiverse
>
> deb http://us.archive.ubuntu.com/ubuntu/ **kinetic-backports** main restricted universe multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **kinetic-backports** main restricted universe multiverse
>
> deb http://archive.canonical.com/ubuntu **kinetic** partner
> deb-src http://archive.canonical.com/ubuntu **kinetic** partner
>
> deb http://security.ubuntu.com/ubuntu **kinetic-security** main restricted
> deb-src http://security.ubuntu.com/ubuntu **kinetic-security** main restricted
> deb http://security.ubuntu.com/ubuntu **kinetic-security** universe
> deb-src http://security.ubuntu.com/ubuntu **kinetic-security** universe
> deb http://security.ubuntu.com/ubuntu **kinetic-security** multiverse
> deb-src http://security.ubuntu.com/ubuntu **kinetic-security** multiverse

### Repositorios Ubuntu Jammy

> deb http://us.archive.ubuntu.com/ubuntu/ **jammy** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy** main restricted
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** main restricted
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy** universe
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** universe
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy** multiverse
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** multiverse
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy-backports** main restricted universe multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy-backports** main restricted universe multiverse
> 
> deb http://archive.canonical.com/ubuntu **jammy** partner
> deb-src http://archive.canonical.com/ubuntu **jammy** partner
> 
> deb http://security.ubuntu.com/ubuntu **jammy-security** main restricted
> deb-src http://security.ubuntu.com/ubuntu **jammy-security** main restricted
> deb http://security.ubuntu.com/ubuntu **jammy-security** universe
> deb-src http://security.ubuntu.com/ubuntu **jammy-security** universe
> deb http://security.ubuntu.com/ubuntu **jammy-security** multiverse
> deb-src http://security.ubuntu.com/ubuntu **jammy-security** multiverse

### Repositorios Ubuntu Bionic

> deb http://us.archive.ubuntu.com/ubuntu/ **bionic** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic** main restricted
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** main restricted
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic** universe
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** universe
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic** multiverse
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** multiverse
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **bionic-backports** main restricted universe multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic-backports** main restricted universe multiverse
> 
> deb http://archive.canonical.com/ubuntu **bionic** partner
> deb-src http://archive.canonical.com/ubuntu **bionic** partner
> 
> deb http://security.ubuntu.com/ubuntu **bionic-security** main restricted
> deb-src http://security.ubuntu.com/ubuntu **bionic-security** main restricted
> deb http://security.ubuntu.com/ubuntu **bionic-security** universe
> deb-src http://security.ubuntu.com/ubuntu **bionic-security** universe
> deb http://security.ubuntu.com/ubuntu **bionic-security** multiverse
> deb-src http://security.ubuntu.com/ubuntu **bionic-security** multiverse

### Repositorios de Debian 10 Buster

> \\# Repositorio base estable.
> deb http://deb.debian.org/debian/ buster main contrib non-free
> deb-src http://deb.debian.org/debian/ buster main contrib non-free
>  
> \\# Repositorio de actualizaciones de seguridad
> deb http://security.debian.org/debian-security buster/updates main contrib non-free
> deb-src http://security.debian.org/debian-security buster/updates main contrib non-free
>  
> \\# Repositorio de actualizaciones anteriormente conocido como "Volátil"
> deb http://deb.debian.org/debian/ buster-updates main contrib non-free
> deb-src http://deb.debian.org/debian/ buster-updates main contrib non-free
>  
> \\# Backports contrib
> deb http://deb.debian.org/debian buster-backports main contrib non-free
> deb-src http://deb.debian.org/debian buster-backports main contrib non-free
>  
> \\# Repositorio multimedia
> deb http://www.deb-multimedia.org buster main non-free
> 
> \\# Fuente: https://www.zeppelinux.es/repositorios-de-debian-10-buster/
`;

export default article2;